module.exports = __webpack_public_path__ + "img/fruit-pineapple-190x100.b2a9f56b.jpg";